import React from 'react';

export function Norway(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="513" height="342" fill="#EF2B2D"/>
      <rect x="0" y="126" width="513" height="90" fill="white"/>
      <rect x="126" y="0" width="90" height="342" fill="white"/>
      <rect x="0" y="136" width="513" height="70" fill="#002868"/>
      <rect x="136" y="0" width="70" height="342" fill="#002868"/>
    </svg>
  );
}
